import React from "react";
import styled from "styled-components";
import Title from "../Common/Title";

import { useNavigate } from "react-router-dom";
import { MdError } from "react-icons/md";

import { ERROR_COLOR } from "../../const";

const Wrapper = styled.div`
    display: flex;
    width: 100%;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
        color: ${ERROR_COLOR[500]};

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        & svg {
            margin-right: 16px;
            width: 2.4rem;
            height: 2.4rem;
        }

        & span {
            font-weight: 600;
            font-size: 2.4rem;
            line-height: 3rem;
        }
    }

    .link {
        cursor: pointer;
        margin-top: 12px;

        &:hover {
            text-decoration: underline;
        }
    }

`;

const Error404 = () => {
    const navigate = useNavigate();
    return (
        <Wrapper>
            <Title desc="404" />
            <div className="title">
                <MdError />
                <span>404 Error</span>
            </div>
            <div className="link" onClick={() => navigate('/')}>
                Go to Home Page
            </div>
        </Wrapper>
    );
};

export default Error404;